import moment from "moment-timezone";
import React from "react";

export const convertBookingObj = (booking) => {
  let sortDate =
    moment(
      moment(booking.date * 1000).format("YYYY-MM-DD") +
        "T" +
        booking.time +
        ":00+01:00"
    ).unix() - moment().tz("Europe/Paris").unix();
  if (sortDate < 0) {
    sortDate *= -1000000;
  }

  let flightProviderMatch = booking.lastname.match(/\((.*)\)/);
  let flightProvider =
    flightProviderMatch && flightProviderMatch.length > 1
      ? flightProviderMatch[1]
      : "";

  return {
    ...booking,
    name: booking.firstname + " " + booking.lastname,
    pickup_date: {
      dateMoment: moment(
        moment(booking.date * 1000)
          .tz("Europe/Paris")
          .format("YYYY-MM-DD") +
          " " +
          booking.time
      ),
      date: moment(
        moment(booking.date * 1000)
          .tz("Europe/Paris")
          .format("YYYY-MM-DD") +
          " " +
          booking.time
      ).format("DD MMM YYYY HH:mm"),
      displayDate: moment(
        moment(booking.date * 1000)
          .tz("Europe/Paris")
          .format("YYYY-MM-DD") +
          " " +
          booking.time
      ).format("dddd DD MMM YYYY à HH:mm"),
      sortDate: sortDate,
    },
    driver: booking.driver ? booking.driver.name : "",
    driver_phone: booking.driver ? booking.driver.phone : "",
    company: booking.driver ? booking.driver.company.name : "",
    id: booking.id ? booking.id : booking.key,
    driverId: booking.driver ? booking.driver.id : "",
    pickup_address: booking.pickup.address.replace(/\\/g, ""),
    dropoff_address: booking.dropoff.address.replace(/\\/g, ""),
    flight_number:
      booking.flight_number +
      (flightProvider ? " (" + flightProvider + ")" : ""),
    status: (
      <span className="kt-badge kt-badge--inline kt-badge--warning">
        {booking.status}
      </span>
    ),
    driver_price: booking.driver_price ? booking.driver_price : 70,
  };
};

export const getBooking = (start, end, company, provider) => {
  return async (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    let bookings = [];

    const auth = firebase.auth();
    dispatch({ type: "LOADING_BOOKING", data: { start: start, end: end } });

    await firebase
      .ref("users/" + auth.uid + "/booking")
      .orderByChild("date")
      .startAt(start)
      .endAt(end)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((childSnapshot) => {
            let sortDate =
              moment(
                moment(childSnapshot.val().date * 1000).format("YYYY-MM-DD") +
                  "T" +
                  childSnapshot.val().time +
                  ":00+01:00"
              ).unix() - moment().tz("Europe/Paris").unix();
            if (sortDate < 0) {
              sortDate *= -1000000;
            }

            if (company && provider) {
              if (childSnapshot.val().driver) {
                firebase
                  .ref("users/" + auth.uid + "/customer")
                  .orderByChild("email")
                  .equalTo(childSnapshot.val().email)
                  .once("value")
                  .then((snapshot2) => {
                    if (snapshot2.exists()) {
                      snapshot2.forEach((childSnapshot2) => {
                        if (
                          company === childSnapshot.val().driver.company.key &&
                          provider === childSnapshot2.val().provider.id
                        ) {
                          bookings.push({
                            ...childSnapshot.val(),
                            name:
                              childSnapshot.val().firstname +
                              " " +
                              childSnapshot.val().lastname,
                            pickup_date: {
                              date: moment(
                                moment(childSnapshot.val().date * 1000).format(
                                  "YYYY-MM-DD"
                                ) +
                                  " " +
                                  childSnapshot.val().time
                              ).format("DD MMM YYYY HH:mm"),
                              sortDate: sortDate,
                            },
                            driver: childSnapshot.val().driver
                              ? childSnapshot.val().driver.name
                              : "",
                            company: childSnapshot.val().driver
                              ? childSnapshot.val().driver.company.name
                              : "",
                            id: childSnapshot.val().id
                              ? childSnapshot.val().id
                              : childSnapshot.key,
                            pickup_address: childSnapshot
                              .val()
                              .pickup.address.replace(/\\/g, ""),
                            dropoff_address: childSnapshot
                              .val()
                              .dropoff.address.replace(/\\/g, ""),
                            status: (
                              <span className="kt-badge kt-badge--inline kt-badge--warning">
                                {childSnapshot.val().status}
                              </span>
                            ),
                            driver_price: childSnapshot.val().driver_price
                              ? childSnapshot.val().driver_price
                              : 70,
                          });
                        }
                      });
                    }
                  });
              }
            } else if (company) {
              if (childSnapshot.val().driver) {
                if (company === childSnapshot.val().driver.company.key) {
                  bookings.push({
                    ...childSnapshot.val(),
                    name:
                      childSnapshot.val().firstname +
                      " " +
                      childSnapshot.val().lastname,
                    pickup_date: {
                      date: moment(
                        moment(childSnapshot.val().date * 1000).format(
                          "YYYY-MM-DD"
                        ) +
                          " " +
                          childSnapshot.val().time
                      ).format("DD MMM YYYY HH:mm"),
                      sortDate: sortDate,
                    },
                    driver: childSnapshot.val().driver
                      ? childSnapshot.val().driver.name
                      : "",
                    company: childSnapshot.val().driver
                      ? childSnapshot.val().driver.company.name
                      : "",
                    id: childSnapshot.val().id
                      ? childSnapshot.val().id
                      : childSnapshot.key,
                    pickup_address: childSnapshot
                      .val()
                      .pickup.address.replace(/\\/g, ""),
                    dropoff_address: childSnapshot
                      .val()
                      .dropoff.address.replace(/\\/g, ""),
                    status: (
                      <span className="kt-badge kt-badge--inline kt-badge--warning">
                        {childSnapshot.val().status}
                      </span>
                    ),
                    driver_price: childSnapshot.val().driver_price
                      ? childSnapshot.val().driver_price
                      : 70,
                  });
                }
              }
            } else if (provider) {
              firebase
                .ref("users/" + auth.uid + "/customer")
                .orderByChild("email")
                .equalTo(childSnapshot.val().email)
                .once("value")
                .then((snapshot2) => {
                  if (snapshot2.exists()) {
                    snapshot2.forEach((childSnapshot2) => {
                      if (provider === childSnapshot2.val().provider.id) {
                        bookings.push({
                          ...childSnapshot.val(),
                          name:
                            childSnapshot.val().firstname +
                            " " +
                            childSnapshot.val().lastname,
                          pickup_date: {
                            date: moment(
                              moment(childSnapshot.val().date * 1000).format(
                                "YYYY-MM-DD"
                              ) +
                                " " +
                                childSnapshot.val().time
                            ).format("DD MMM YYYY HH:mm"),
                            sortDate: sortDate,
                          },
                          driver: childSnapshot.val().driver
                            ? childSnapshot.val().driver.name
                            : "",
                          company: childSnapshot.val().driver
                            ? childSnapshot.val().driver.company.name
                            : "",
                          id: childSnapshot.val().id
                            ? childSnapshot.val().id
                            : childSnapshot.key,
                          pickup_address: childSnapshot
                            .val()
                            .pickup.address.replace(/\\/g, ""),
                          dropoff_address: childSnapshot
                            .val()
                            .dropoff.address.replace(/\\/g, ""),
                          status: (
                            <span className="kt-badge kt-badge--inline kt-badge--warning">
                              {childSnapshot.val().status}
                            </span>
                          ),
                          driver_price: childSnapshot.val().driver_price
                            ? childSnapshot.val().driver_price
                            : 70,
                        });
                      }
                    });
                  }
                });
            } else {
              bookings.push({
                ...childSnapshot.val(),
                name:
                  childSnapshot.val().firstname +
                  " " +
                  childSnapshot.val().lastname,
                pickup_date: {
                  date: moment(
                    moment(childSnapshot.val().date * 1000).format(
                      "YYYY-MM-DD"
                    ) +
                      " " +
                      childSnapshot.val().time
                  ).format("DD MMM YYYY HH:mm"),
                  sortDate: sortDate,
                },
                driver: childSnapshot.val().driver
                  ? childSnapshot.val().driver.name
                  : "",
                company: childSnapshot.val().driver
                  ? childSnapshot.val().driver.company.name
                  : "",
                id: childSnapshot.val().id
                  ? childSnapshot.val().id
                  : childSnapshot.key,
                pickup_address: childSnapshot
                  .val()
                  .pickup.address.replace(/\\/g, ""),
                dropoff_address: childSnapshot
                  .val()
                  .dropoff.address.replace(/\\/g, ""),
                status: (
                  <span className="kt-badge kt-badge--inline kt-badge--warning">
                    {childSnapshot.val().status}
                  </span>
                ),
                driver_price: childSnapshot.val().driver_price
                  ? childSnapshot.val().driver_price
                  : 70,
              });
            }
          });
        }
      });

    setTimeout(() => {
      dispatch({ type: "LOADED_BOOKING", data: bookings });
    }, 1000);
  };
};
